import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(blank-layout)/error.tsx");
